import _map from 'lodash/map';
import _filter from 'lodash/filter';

export type PartCredentialType = {
  Policy: string;
  Signature: string;
  'Key-Pair-Id': string;
};

// This takes all the key/value pairs of the partCredentials mapping and adds
// them as URL params to each part URL in the playlist file. Example:
//
// partCredentials: { 'Key-Pair-Id': 'ABCD', 'Expires': 100000, 'Token': 'EFGH' }
// output: '?Key-Pair-Id=ABCD&Expires=100000&Token=EFGH'
//
// Now 'output' can be appended to each part file in the playlist like so:
//
// cloudfront.net/sessions/raw/<video_id><output>
export const getCredentialParamsString = (
  partCredentials: Partial<PartCredentialType>
): string => {
  const nonEmptyKeys = _filter(
    Object.keys(partCredentials),
    paramKey => partCredentials[paramKey].length > 0
  );

  return `${_map(nonEmptyKeys, paramKey => {
    return `${paramKey}=${window.encodeURIComponent(
      partCredentials[paramKey]
    )}`;
  }).join('&')}`;
};
